









































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AuthorizedSignerTable from "@/employee/components/settings/AuthorizedSignerTable.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { AuthorizedSigner, AuthorizedSignerStatus } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import EditAuthorizedSigner from "@/employee/components/settings/EditAuthorizedSigner.vue";

const emptyAuthorizedSigner: AuthorizedSigner = {
    id: 0,
    firstName: "",
    middleInitial: "",
    lastName: "",
    dateOfBirth: "",
    ssn: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    status: AuthorizedSignerStatus.Active,
    externalId: ""
  };

@Component({
  components: {
    GenericLoadingSpinner,
    AuthorizedSignerTable,
    EditAuthorizedSigner
  }
})
export default class AuthorizedSigners extends Vue {
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();

  editAuthorizedSignerParameters = {
    show: { value: false },
    authorizedSigner: { ...emptyAuthorizedSigner },
    onSave: this.onSaveAuthorizedSigner,
    toggleClose: this.closeEditAuthorizedSignerForm,
    isNew: true
  };

  mounted (): void {
    this.bankAccountStore.loadAuthorizedSigners();
  }

  showEditAuthorizedSignerForm () {
    this.editAuthorizedSignerParameters.authorizedSigner = { ...emptyAuthorizedSigner };
    this.editAuthorizedSignerParameters.show.value = true;
  }

  onSaveAuthorizedSigner () {
    return this.bankAccountStore.addAuthorizedSigner(this.editAuthorizedSignerParameters.authorizedSigner)
    .then(() => {
      this.editAuthorizedSignerParameters.show.value = false;
    })
    .catch(() => {/*noop*/});
  }

  closeEditAuthorizedSignerForm () {
  this.editAuthorizedSignerParameters.show.value = false;
}

  get profileAddEditEnabled () {
    return this.featureFlagStore.flags.bend17261EnableProfileAddEdit;
  }

  get isLoaded (): boolean {
    return this.bankAccountStore.isAuthoriziedSignersLoaded;
  }

  get authorizedSigners (): AuthorizedSigner[] {
    return Object.keys(this.bankAccountStore.authorizedSigners).map(key => this.bankAccountStore.authorizedSigners[key]) ;
  }

  get activeAuthorizedSigners (): AuthorizedSigner[] {
    return this.authorizedSigners.filter(x => x.status === AuthorizedSignerStatus.Active);
  }

  get hasActiveAuthorizedSigners (): boolean {
    return this.activeAuthorizedSigners && this.activeAuthorizedSigners.length > 0;
  }

  get inactiveAuthorizedSigners (): AuthorizedSigner[]  {
    return this.authorizedSigners.filter(x => x.status === AuthorizedSignerStatus.Inactive);
  }

  get hasInactiveAuthorizedSigners (): boolean {
    return this.inactiveAuthorizedSigners && this.inactiveAuthorizedSigners.length > 0;
  }
}
